import {Component} from '@angular/core';
import {LoginComponent} from '@domain/common/component/login/login.component';

@Component({
  selector: 'app-auth-login-user',
  imports: [
    LoginComponent
  ],
  templateUrl: './login-user.component.html'
})
export class LoginUserComponent {

}
